import React from 'react';
import InfoBlock from '../Shared/InfoBlock';

const isEmpty = (val) => !val || val.trim() === '';

const formatZip = (zip) => {
    if (!zip) return '';
    const cleaned = zip.toString().replace(/\D/g, ''); // remove non-digits
    return cleaned.length > 5
        ? `${cleaned.slice(0, 5)}-${cleaned.slice(5, 9)}`
        : cleaned;
};

const AgentCard = ({ title, agent }) => {
    if (!agent) return null;

    const hasAddress = agent.address || agent.address2 || agent.city || agent.state || agent.zip;
    const displayAddress = hasAddress ? (
        <>
            {agent.address && <>{agent.address}<br /></>}
            {agent.address2 && <>{agent.address2}<br /></>}
            {(agent.city || agent.state || agent.zip) && (
                <>
                    {[agent.city, agent.state].filter(Boolean).join(', ')} {formatZip(agent.zip)}
                </>
            )}
        </>
    ) : null;

    return (
        <div className="personCard">
            <div className="personCardHeader">{title}</div>
            <div className="personCardBody">
                <InfoBlock label="Name:" value={agent.name} />
                <InfoBlock label="Phone:" value={agent.displayPhoneNumber} />
                <InfoBlock label="Email:" value={agent.email} />
                {/*{hasAddress && <InfoBlock label="Address:" value={displayAddress} />}*/}
            </div>
        </div>
    );
};

export default AgentCard;
